/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import AmountToWords from "../../../../components/_utils/AmountToWords";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import CommonToast from "../../../../components/_utils/CommonToast";
import SVGComponent from "../../../../components/_utils/SVGComponent";
import TaxTransactionStepAccount from "../../../../components/Transactions/TaxTransaction/TaxTransactionCreate/TaxTransactionStepAccount";
import TaxTransactionStepAdditionalDetails from "../../../../components/Transactions/TaxTransaction/TaxTransactionCreate/TaxTransactionStepAdditionalDetails";
import TaxTransactionStepAmount from "../../../../components/Transactions/TaxTransaction/TaxTransactionCreate/TaxTransactionStepAmount";
import TaxTransactionStepConfirm from "../../../../components/Transactions/TaxTransaction/TaxTransactionCreate/TaxTransactionStepConfirm";
import { uploadImages } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { createTdsTransaction } from "../../../../redux/features/transactions/taxTransaction/taxTransactionCreate";
import { tdsTxnViewAll } from "../../../../redux/features/transactions/taxTransaction/taxTransactionViewAll";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";

const TaxationTransactionCreate = () => {
  const steps = [
    globalText?.SOURCE_AND_DESTINATION_ACCOUNT,
    globalText?.ADDITIONAL_DETAILS_AND_LABELS,
    globalText?.TRANSFER_AMOUNT,
    globalText?.CONFIRM_AND_CREATE,
  ];

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const scrollIt = useRef(null);
  const hasAutoFillInteracted = useRef(false);
  const currentAccountDetails = location?.state;
  const [endDate, setEndDate] = useState({});
  const [isNeft, setIsNeft] = useState(true);
  const [isRtgs, setIsRtgs] = useState(false);
  const [timeData, setTimeData] = useState({});
  const [catShow, setCatShow] = useState(false);
  const [openBar, setOpenBar] = useState(false);
  const [startDate, setStartDate] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [hyperLinks, setHyperLinks] = useState({});
  const [quantities, setQuantities] = useState({});
  const [labelsAcc, setLabelsAcc] = useState(null);
  const [direction, setDirection] = useState(null);
  const [catSelect, setCatSelect] = useState(false);
  const [openOwner, setOpenOwner] = useState(false);
  const [txnLoading, setTxnLoading] = useState(false);
  const [startDateCal, setStartDateCal] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [previewImages, setPreviewImages] = useState({});
  const [selectedValue, setSelectedValue] = useState({});
  const [sourceSelect, setSourceSelect] = useState(false);
  const [additionalData, setAdditionalData] = useState({});
  const [accountSelect, setAccountSelect] = useState(false);
  const [isNextEnabled, setIsNextEnabled] = useState(false);
  const [isConfidential, setIsConfidential] = useState(false);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showSimilarModal, setShowSimilarModal] = useState(false);
  const [selectedValueMonth, setSelectedValueMonth] = useState({});
  const [similarTransaction, setSimilarTransaction] = useState(false);
  const [transactionDisable, setTransactionDisable] = useState(false);
  const [isStepper, setIsStepper] = useState(window.innerWidth <= 800);

  const [txnPayLoad, setTxnPayLoad] = useState({
    taxAccountBankName: currentAccountDetails?.name
      ? currentAccountDetails.name
      : "",
    taxAccountId: currentAccountDetails?.id ? currentAccountDetails?.id : "",
    bankAccountIFSC: currentAccountDetails?.ifsc_code
      ? currentAccountDetails?.ifsc_code
      : "",
    bankAccountNo: currentAccountDetails?.bank_acc_no
      ? currentAccountDetails?.bank_acc_no
      : "",
    categories: currentAccountDetails?.category
      ? currentAccountDetails?.category
      : "",
    amount: "",
    settleType: "",
    bankLogo: currentAccountDetails?.bank_name
      ? currentAccountDetails?.bank_name
      : "",
    pan: currentAccountDetails?.pan ? currentAccountDetails?.pan : "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: 0,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: null,
    mergeCategory: null,
    amountInWords: "",
    labels: currentAccountDetails?.labels ? currentAccountDetails?.labels : [],
    ownerLabels: [],
  });
  const [category, setCategory] = useState(
    txnPayLoad?.categories ? txnPayLoad?.categories?.split(",") : [],
  );
  const animationClassS =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const isValidHttpUrl = (url) => {
    const httpRegex =
      /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/.*)?$/;
    return httpRegex.test(url);
  };

  const categories = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );

  const { beneTxnAccountData } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );

  const handleCategory = (selectedCategoryData) => {
    setSelectedCategory(selectedCategoryData);
  };

  const handleKeyDown = (event) => {
    if (
      event.target.tagName === "INPUT" ||
      event.target.tagName === "TEXTAREA"
    ) {
      if (event.key === "Tab") {
        event.preventDefault();
      }
    } else if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Tab"
    ) {
      event.preventDefault();
    }
  };

  const handleCreateTransaction = async () => {
    if (transactionDisable) return;
    setTransactionDisable(true);

    let haveImage = txnPayLoad?.mergeCategory?.some((val) => {
      return val?.data_type === "upload" && val?.value !== "Not Given";
    });

    let storeData;

    let add = 0;

    if (haveImage) {
      const responseUpload = await Promise.all(
        Object.values(uploadedFiles).map((file) =>
          dispatch(uploadImages(file)),
        ),
      );
      if (responseUpload) {
        storeData = selectedCategory?.configuration?.data?.map((val) => {
          if (additionalData[val?.name]) {
            const dataValue = additionalData[val?.name];
            if (val?.data_type === "numeric") {
              const integerValue = parseInt(dataValue, 10);
              if (!isNaN(integerValue)) {
                return { ...val, value: integerValue };
              } else {
                throw new Error(
                  `Value '${dataValue}' is not a valid integer for category '${val?.name}'`,
                );
              }
            } else if (val?.data_type === "upload") {
              const { description, ...rest } = val;
              return { ...rest, value: responseUpload[add++]?.payload };
            } else if (val?.data_type === "toggle") {
              const { description, ...rest } = val;
              return { ...rest, value: dataValue };
            } else {
              return { ...val, value: dataValue };
            }
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest };
          }
          return val;
        });
      }
    } else {
      storeData = selectedCategory?.configuration?.data?.map((val) => {
        if (additionalData[val?.name]) {
          const dataValue = additionalData[val?.name];
          if (val?.data_type === "numeric") {
            const integerValue = parseInt(dataValue, 10);
            if (!isNaN(integerValue)) {
              return { ...val, value: integerValue };
            } else {
              throw new Error(
                `Value '${dataValue}' is not a valid integer for category '${val?.name}'`,
              );
            }
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest, value: dataValue };
          } else {
            return { ...val, value: dataValue };
          }
        } else if (val?.data_type === "toggle") {
          const { description, ...rest } = val;
          return { ...rest };
        }
        return val;
      });
    }

    const payload = {
      amount: txnPayLoad.amount,
      owner_account_id: txnPayLoad.ownerId,
      tds_account_id: txnPayLoad.taxAccountId,
      additional_data: {
        data: storeData,
      },
      category: selectedCategory?.name,
      payment_method: txnPayLoad.settleType.toUpperCase(),
      confidential_transaction: isConfidential,
      labels: [...(txnPayLoad.labels || []), ...(txnPayLoad.ownerLabels || [])],
    };

    const successResponse = await dispatch(createTdsTransaction(payload));
    if (createTdsTransaction.fulfilled.match(successResponse)) {
      const transactionId = successResponse.payload?.transaction?.[0]?.txn_id;

      navigate(
        `/tax_transaction_dashboard/create_tax_transaction/success/${transactionId}`,
      );

      setTransactionDisable(false);
      return;
    }
    const errorPayload = successResponse?.payload ||
      successResponse?.error || { message: "Transaction failed" };

    sessionStorage.setItem("tax_txn_error", JSON.stringify(errorPayload));
    navigate("/tax_transaction_dashboard/create_tax_transaction/failed");
    setTransactionDisable(false);
  };

  const queryParams = () => ({
    page_no: GlobalConfiguration?.lengthCheckOne,
    page_item_count: PaginationConfiguration?.paginationSmall,
    amount: txnPayLoad?.amount,
    payment_method: txnPayLoad?.settleType?.toUpperCase(),
    tds_account_id: txnPayLoad?.taxAccountId,
    owner_account_id: txnPayLoad?.ownerId,
    confidential_transaction: isConfidential
      ? "Show only confidential"
      : !isConfidential
        ? "Hide confidential"
        : undefined,
  });

  const handleNext = async () => {
    hasAutoFillInteracted.current = false;
    if (isButtonDisabled) return;
    setButtonDisabled(true);
    try {
      if (activeStep === GlobalConfiguration.lengthCheckTwo) {
        setTxnLoading(true);
        const res = await dispatch(tdsTxnViewAll(queryParams()));
        const hasDuplicates =
          res?.payload?.transactions?.length >
          GlobalConfiguration?.lengthCheckZero;

        setSimilarTransaction(hasDuplicates);

        if (hasDuplicates) {
          toast.dismiss();
          CommonToast({
            text: "Few issues found click check to view.",
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
        setActiveStep((prev) => prev + GlobalConfiguration.lengthCheckOne);

        setDirection("next");
        setTxnLoading(false);
        setRemoveClassName(false);
        setTimeout(() => {
          setRemoveClassName(true);
        }, IntervalConfiguration?.intervalSemiMid);

        setOpenBar(false);
      } else if (activeStep === GlobalConfiguration.lengthCheckThree) {
        if (similarTransaction) {
          setShowSimilarModal(true);
        } else {
          await handleCreateTransaction();
        }
      } else {
        setActiveStep((prev) => prev + GlobalConfiguration.lengthCheckOne);

        setDirection("next");

        setRemoveClassName(false);
        setTimeout(() => {
          setRemoveClassName(true);
        }, IntervalConfiguration?.intervalSemiMid);

        setTimeout(() => {
          setButtonDisabled(false);
        }, IntervalConfiguration?.intervalSmaller);
        setOpenBar(false);
      }
    } finally {
      setButtonDisabled(false);
    }
  };

  const handleBack = () => {
    hasAutoFillInteracted.current = false;
    if (isButtonDisabled) return;

    if (activeStep === 0) {
      navigate(-1);
      return;
    }
    setButtonDisabled(true);
    try {
      setActiveStep((prev) => (prev ? prev - 1 : 0));

      setDirection("previous");
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration?.intervalSemiMid);
      setOpenBar(false);
    } finally {
      setButtonDisabled(false);
    }
  };

  const commonStepperConfig = {
    previousEnableBgColor: "var(--primary-nav-act)",
    previousDisableBgColor: "var(--text-disabled)",
    previousEnableTextColor: "var(--text-primary)",
    previousHoverOption: "white",
    nextEnableBgColor: "var(--text-primary)",
    nextDisableBgColor: "var(--text-disabled)",
    nextEnableTextColor: "var(--primary-bg)",
    nextDisableTextColor: "var(--text-primary)",
    nextHoverOption: "black",
  };

  const dataArray = steps.map((stepLabel, index) => {
    const isLastStep = index === steps.length - 1;
    const isTxnLoading = isLastStep && transactionDisable;
    return {
      ...commonStepperConfig,
      previousText:
        index === GlobalConfiguration.lengthCheckZero ? "Cancel" : "Previous",
      previousIsDisabled: isTxnLoading,
      nextText: isLastStep ? (similarTransaction ? "Check" : "Create") : "Next",
      nextLoaderNeeded: isLastStep,
      nextIsLoading: isTxnLoading,
      nextIsEnabled: isLastStep
        ? !transactionDisable
        : isNextEnabled && !isButtonDisabled,
      nextEnableBgColor: isLastStep
        ? similarTransaction
          ? "var(--emphasis)"
          : "var(--positive-act)"
        : "var(--text-primary)",
      nextDisableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--primary-bg)",
      nextDisableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--text-primary)",
      stepperText: stepLabel,
    };
  });

  const renderCreateTxn = () => {
    switch (activeStep) {
      case 0:
        return (
          <TaxTransactionStepAccount
            catName={beneTxnAccountData?.transaction?.[0]?.category}
            catShow={catShow}
            setCatShow={setCatShow}
            catSelect={catSelect}
            setCatSelect={setCatSelect}
            accountSelect={accountSelect}
            setAccountSelect={setAccountSelect}
            sourceSelect={sourceSelect}
            setSourceSelect={setSourceSelect}
            category={category}
            setCategory={setCategory}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            handleCategorySelect={handleCategory}
            categories={categories}
            setAdditionalData={setAdditionalData}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            setSelectedValue={setSelectedValue}
            setSelectedValueMonth={setSelectedValueMonth}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setStartDateCal={setStartDateCal}
            setQuantities={setQuantities}
            setHyperLink={setHyperLinks}
            setPreviewImages={setPreviewImages}
            setUploadedFiles={setUploadedFiles}
            setTimeData={setTimeData}
            labelsAcc={labelsAcc}
            setLabelsAcc={setLabelsAcc}
            openOwner={openOwner}
            setOpenOwner={setOpenOwner}
            isConfidential={isConfidential}
            setIsConfidential={setIsConfidential}
            setHasUserSelectedAccount={(e) => {}}
          />
        );
      case 1:
        return (
          <TaxTransactionStepAdditionalDetails
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            startDateCal={startDateCal}
            setStartDateCal={setStartDateCal}
            quantities={quantities}
            setQuantities={setQuantities}
            hyperLink={hyperLinks}
            setHyperLink={setHyperLinks}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            previewImages={previewImages}
            setPreviewImages={setPreviewImages}
            timeData={timeData}
            setTimeData={setTimeData}
          />
        );
      case 2:
        return (
          <TaxTransactionStepAmount
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            isNeft={isNeft}
            setIsNeft={setIsNeft}
            isRtgs={isRtgs}
            setIsRtgs={setIsRtgs}
            amountInWords={txnPayLoad.amountInWords}
            txnLoading={txnLoading}
          />
        );
      case 3:
        return (
          <TaxTransactionStepConfirm
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            isConfidential={isConfidential}
            previewImages={previewImages}
            showSimilarModal={showSimilarModal}
            setShowSimilarModal={setShowSimilarModal}
            queryParams={queryParams()}
            onForceCreate={handleCreateTransaction}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const configData = txnPayLoad?.selectedCategory?.configuration?.data || [];
    const mergeCategory = txnPayLoad?.mergeCategory || [];

    const mandatoryFields = configData.filter((v) => v?.mandatory === "Y");

    const filledMandatoryFields = mergeCategory.filter((v) => {
      if (v?.mandatory !== "Y") return false;

      switch (v?.data_type) {
        case "multi_select_list":
          return Array.isArray(v.value) && v.value.length > 0;

        case "from_year_to_year": {
          const from = v?.value?.from;
          const to = v?.value?.to;

          const bothEmpty = !from && !to;
          const bothFilled = from && to;

          if (bothEmpty && v?.mandatory !== "Y") {
            return true;
          }

          return bothFilled;
        }

        case "date_range":
          return v?.value?.start_date && v?.value?.end_date;

        case "toggle":
          return v?.value === true;

        default:
          return v?.value !== "" && v?.value !== undefined;
      }
    });

    const isMandatoryFieldsFilled =
      mandatoryFields.length === filledMandatoryFields.length;

    const isHyperlinkHave = mergeCategory.some(
      (v) => v?.data_type === "hyperlink",
    );

    const isHyperlinkValid = mergeCategory
      .filter((v) => v?.data_type === "hyperlink" && v?.value !== "")
      .every((v) => isValidHttpUrl(v?.value));

    const isAmountValid = txnPayLoad?.amount > 0;

    const isRtgsSelected = txnPayLoad?.settleType === "rtgs";
    const isRtgsValid = !isRtgsSelected || txnPayLoad?.amount >= 200000;

    const isSettleTypeValid =
      txnPayLoad?.settleType &&
      !(
        (txnPayLoad?.settleType === "imps" && txnPayLoad?.amount > 200000) ||
        (txnPayLoad?.settleType === "rtgs" && txnPayLoad?.amount <= 200000) ||
        (txnPayLoad?.settleType === "neft" && txnPayLoad?.amount > 200000)
      );

    let isStepValid = false;

    switch (activeStep) {
      case 0:
        isStepValid =
          !!txnPayLoad?.ownerId &&
          !!txnPayLoad?.taxAccountId &&
          !!txnPayLoad?.selectedCategory;
        break;

      case 1:
        isStepValid =
          isMandatoryFieldsFilled && (!isHyperlinkHave || isHyperlinkValid);
        break;

      case 2:
        isStepValid = isAmountValid && isRtgsValid && isSettleTypeValid;
        break;

      case 3:
        isStepValid = true;
        break;

      default:
        isStepValid = false;
    }
    setIsNextEnabled(isStepValid);
  }, [activeStep, txnPayLoad, hyperLinks]);

  useEffect(() => {
    if (
      location?.state?.txnDetails?.reminderAmount &&
      txnPayLoad?.amount === ""
    ) {
      const amount = parseFloat(location.state.txnDetails.reminderAmount);

      let words = AmountToWords(amount) || "";

      if (amount >= 1 && amount <= 9) {
        words = words.replace("rupees", "rupee");
      }

      setTxnPayLoad((prev) => ({
        ...prev,
        amount: amount,
        amountInWords: words,
      }));
    }
  }, [location]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 800;

      setIsStepper(mobile);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div
      className="w-width-full flex justify-start items-center flex-col bg-primary-bg overflow-y-auto"
      style={{
        height:
          openOwner || isModalOpen
            ? "var(--height-full)"
            : "var(--full-height)",
      }}
    >
      <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height Qlg:bg-transparent bg-primary-nav flex-shrink-0"></div>
      <div className="fixed Qsmd:relative left-left-base z-z-index-loader flex justify-center items-center flex-col lg:flex-col-reverse w-width-full lg:py-padding-base bottom-bottom-base top-auto lg:top-top-base lg:bottom-auto Qsmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-height Qsmd:bg-transparent">
        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>
      {isStepper && (
        <>
          <div className="flex items-center w-full-width h-mobile-create-header bg-primary-nav px-padding-md py-padding-sm top-top-base z-z-index-header shadow-box-shadow-bottom rounded-b-border-radius-sm">
            <div
              className="cursor-pointer"
              onClick={() => {
                if (openBar) {
                  setOpenBar(false);
                } else if (activeStep === 0) {
                  navigate("/tax_transaction_dashboard");
                } else {
                  navigate(-1);
                }
              }}
            >
              <SVGComponent
                url={ICONS?.ARROW_LEFT_WHITE}
                color={"var(--text-primary)"}
                height={"var(--icon-md)"}
                width={"var(--icon-md)"}
                alt="Arrow"
              />
            </div>
            <div className="flex flex-col gap-gap-xs ml-margin-md">
              <div className="text-text-primary text-base">Tax transaction</div>

              <div className="text-text-secondary text-xs">
                {steps[activeStep] || ""}
              </div>
            </div>
          </div>
        </>
      )}
      <div
        className="overflow-hidden h-full flex flex-col items-center relative w-width-full"
        ref={scrollIt}
      >
        <>
          <div
            className={`w-width-full h-height-full mb-margin-base overflow-y-auto ${
              activeStep === 0 && direction === "next"
                ? ""
                : removeClassName === true
                  ? ""
                  : animationClassS
            }`}
          >
            {renderCreateTxn()}
          </div>
        </>
      </div>
    </div>
  );
};

export default TaxationTransactionCreate;
